module.exports = __webpack_public_path__ + "img/chat-square-quote-fill.4ab85968.svg";